import { render, staticRenderFns } from "./TestVueEditor.vue?vue&type=template&id=6a94d224&"
import script from "./TestVueEditor.vue?vue&type=script&lang=js&"
export * from "./TestVueEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports